import { InputFieldGroupCombinedProps } from './types';

const usePresenter = (props: InputFieldGroupCombinedProps): InputFieldGroupCombinedProps => {
  return props;
};

export default usePresenter;
